import { render, staticRenderFns } from "./FiltersDialog.vue?vue&type=template&id=7889e42d"
import script from "./FiltersDialog.vue?vue&type=script&lang=js"
export * from "./FiltersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports